var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex gl-flex-col gl-justify-between gl-pt-5 sm:gl-flex-row sm:gl-items-center"},[_c('h2',{staticClass:"gl-heading-2 gl-mb-0 gl-mt-5"},[_vm._v(_vm._s(_vm.$options.i18n.headerText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }